var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatIcon = function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 60"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.889 1H12.11C5.975 1 1 5.925 1 12v11c0 6.078 4.975 11 11.111 11h2.778v11l12.5-11h12.5C46.025 34 51 29.078 51 23V12c0-6.075-4.975-11-11.111-11M31 44.15c0 3.729 3.17 6.75 7.083 6.75h7.084l8.5 8.1v-8.1h4.25C61.83 50.9 65 47.879 65 44.15v-5.4c0-3.729-3.17-6.75-7.083-6.75"
  }))));
};
export default SvgChatIcon;